export default class Form
{
	init (form)
	{
		this.params = app_form
		this.form = form
		this.action = form.querySelector('input[type="hidden"][name="action"]') ? form.querySelector('input[type="hidden"][name="action"]').value : 'process_form'
		this.button = form.querySelector('button') || form.querySelector('input[type="submit"]')
		this.loader = form.querySelector('.loader')
		this.messages = form.querySelector('.messages')
		
		if (!this.messages)
		{
			const div = document.createElement('div')
			div.className = 'messages'
			
			form.append(div)
			
			this.messages = div
		}
		
		form.addEventListener('submit', (e) =>
		{
			e.preventDefault()
			
			this.send()
		})
	}
	
	send ()
	{
		const data = new FormData(this.form)
		
		data.append('action', this.action)
		data.append('security', this.params.nonce)
		data.append('post_id', this.params.post_id)
		
		this.req(data, false)
	}
	
	addMessage (message, success = true)
	{
		this.messages.dataset.type = success ? 'success' : 'error'
		this.messages.innerHTML = ''
		
		if (Array.isArray(message))
		{
			message.forEach(el =>
			{
				this.messages.innerHTML += `<p>${el}</p>`
			})
		}
		else
		{
			this.messages.innerHTML += `<p>${message}</p>`
		}
	}
	
	async req (data, enableFieldsAfterSuccess = true)
	{
		const fields = Array.from(this.form.elements)
		
		this.form.classList.add('loading')
		
		fields.forEach(el =>
		{
			el.disabled = true
		})
		
		return await fetch(app.ajax_url, {
			method: 'POST',
			body: data,
			headers: {
				'X-Requested-With': 'XMLHttpRequest'
			}
		}).then((response) =>
		{
			return response.ok ? response.json() : {
				success: false,
				data: {
					message: response.statusText
				}
			}
		}).then((response) =>
		{
			this.form.classList.remove('loading')
			
			fields.forEach(el =>
			{
				el.disabled = response.success ? !enableFieldsAfterSuccess : false
			})
			
			this.addMessage(response.data.message, response.success)
			
			return response
		}).catch((error) =>
		{
			this.form.classList.remove('loading')
			
			fields.forEach(el =>
			{
				el.disabled = false
			})
			
			this.addMessage(error, false)
		})
	}
}
